/**
 * Склонение числительных.
 *
 * Пример:
 * pluralize(12, ['материал', 'материала', 'материалов']) => 'материалов'
 *
 * @param {number} number
 * @param {array} forms
 */
export default function pluralize(number, forms) {
  let n = Math.abs(number) % 100;
  if (n > 10 && n < 20) return forms[2];
  n = n % 10;
  if (n > 1 && n < 5) return forms[1];
  if (n === 1) return forms[0];
  return forms[2];
}
